/* unplugin-vue-components disabled */import { render } from "./BeltScaleData.vue?vue&type=template&id=79ddc692&scoped=true&ts=true"
import script from "./BeltScaleData.vue?vue&type=script&lang=ts"
export * from "./BeltScaleData.vue?vue&type=script&lang=ts"

import "./BeltScaleData.vue?vue&type=style&index=0&id=79ddc692&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ddc692"]])

export default __exports__